import Axios from 'axios';
import { isAgentLoggedIn } from '../utils/browserUtils';
import { getAffiliate } from '../utils/appUtils';

export const GET_POKUS_API = ssr.isOnClient
  ? '//pokus.makemytrip.com/experiment/assignVariant'
  : 'http://pokus.mmt.mmt/experiment/assignVariant';
export const POKUS_STATUS_API = '/holidays-api/pokus-status-check';
const fetchData = userDeviceId => {
  const headers = {
    'content-type': 'application/json',
  };
  const data = {
    attributes: {
      device_type: 'desktop',
      Affiliate: getAffiliate(),
      Agent_Login: isAgentLoggedIn(),
    },
    lob: 'HOLIDAY',
    user: {
      deviceId: userDeviceId,
    },
    context: {
      pageName: '',
      section: '',
    },
  };
  return Axios({
    method: 'POST',
    headers,
    data: JSON.stringify(data),
    url: GET_POKUS_API,
    timeout: 6000,
  });
};

export const setPokusStatus = res => {
  const headers = {
    'content-type': 'application/json',
  };
  return Axios({
    method: 'POST',
    headers,
    url: POKUS_STATUS_API,
    data: res,
  });
};
export default fetchData;
